import React from "react";
import Skeleton from "react-loading-skeleton";

import { TableListSkeleton } from "components/Skeleton/Skeleton";

const OrderBookSkeleton = () => {
  return <TableListSkeleton Structure={OrderBookSkeletonStructure} count={5} />;
};

const OrderBookSkeletonStructure = () => {
  return (
    <div className="relative grid grid-cols-3">
      <div className="h-32">
        <Skeleton width={80} height={24} inline />
      </div>
      <div className="h-32">
        <Skeleton width={80} height={24} />
      </div>
      <div className="flex h-32 w-full justify-end">
        <Skeleton width={80} height={24} />
      </div>
    </div>
  );
};

export default OrderBookSkeleton;
